import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import machinesSlice from './slices/machinesSlice';
import manualsSlice from './slices/manualsSlice';
import uiSlice from './slices/uiSlice';
import usersSlice from './slices/usersSlice';
import inventorySlice from './slices/inventorySlice';
import activitiesSlice from './slices/activitiesSlice';
import notificationsSlice from './slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    machines: machinesSlice,
    manuals: manualsSlice,
    ui: uiSlice,
    users: usersSlice,
    inventory: inventorySlice,
    activities: activitiesSlice,
    notifications: notificationsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;